import Phaser from "phaser";
import { gameData } from "../../Game.jsx";
import  VfxSprite  from "../classes/VfxSprite.js"
import eventsCenter, { PHASER_EVENTS } from "../../../../utils/phaserEvents";

export default class NamePanel extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, scale, pfp, playerObject, isVip, isMe) {
        super(scene, x, y, 'all_images','name_panel');
        this.scale = (scale*1.65, scale*1.4); //this.scale = 0.924
        this.setDepth(2);
        this.playerId = playerObject.userId;
        this.isMe = isMe;
        const maskGraphics = this.scene.add.graphics();
        maskGraphics.fillStyle(0xffffff); // Set the mask color (white)
        maskGraphics.fillCircle(x - (208*scale), y, 50*scale); // Define the circle's position and radius
        const mask = new Phaser.Display.Masks.GeometryMask(this, maskGraphics);
        this.pfpImage = this.scene.add.image(x - (208*scale), y, pfp).setScale(scale).setDepth(this.depth + 1).setMask(mask); //TO DO: IMPLEMENT BORDER RADIUS!!!
        this.usernameText = this.scene.add.text(this.x + (80.48*scale), this.y + (2.54*scale), playerObject.username.toString(), { fontSize: 52*scale + "px", fontFamily: "TruculentaBold", fill: '#B2F1FF', align: 'center' }).setOrigin(0.5, 0.5).setDepth(this.depth + 1);
        if (isVip) {
            this.vipImage = this.scene.add.image(this.x - (244.94*scale), this.y - (43.18*scale), 'all_images', 'vip').setScale(1.016).setDepth(this.depth + 2);
        }

        //On-fire button
        this.onFireText = this.scene.add.text(this.x + (1*scale), this.y - (56*scale), 'LIT', { fontSize: 60*scale + "px", fontFamily: "TruculentaBold", fill: '#B2F1FF', align: 'center' }).setOrigin(0.5, 0.5).setDepth(this.depth + 3);
        //  Apply the gradient fill.
        const gradient = this.onFireText.context.createLinearGradient(0, 0, 0, this.onFireText.height);
        this.onFireText.setStroke('#000000', 10);
        gradient.addColorStop(0.35, '#7df5d0');
        gradient.addColorStop(0.45, '#6797e1');
        gradient.addColorStop(1, '#48e1fe');

        this.onFireText.setFill(gradient);
        this.onFireText.setVisible(false);
        this.onFireText.setDepth(this.depth + 3);

        this.flameSprites = [];


        //Notification icon
        const offsetX = -this.pfpImage.width * this.scale * 0.4; 
        const offsetY = -this.pfpImage.height * this.scale * 0.5;
    
        this.notifyImage = this.scene.add.image(this.pfpImage.x - offsetX, this.pfpImage.y + offsetY, 'all_images', 'notify').setScale(0.1 * this.scale).setDepth(this.depth + 4);
        this.setNotifyVisible(false);

        eventsCenter.on(PHASER_EVENTS.FRIEND_REQUEST_RECEIVED, (notification) => {
            if(notification.sender_id === this.playerId){
                this.setNotifyVisible(true);
            }
        });
        eventsCenter.on(PHASER_EVENTS.FRIEND_REQUEST_ACCEPTED, (notification) => {
            if(notification.sender_id === this.playerId){
                this.setNotifyVisible(true);
            }
        });

        eventsCenter.on(PHASER_EVENTS.BONE_RECEIVED, (notification) => {
            if(notification.sender_id === this.playerId){
                this.setNotifyVisible(true);
            }
        });
        eventsCenter.on(PHASER_EVENTS.BONE_COLLECTED, (notification) => {
            if(notification.sender_id === this.playerId){
                //this.setNotifyVisible(true);
                //We will show an ingame animated notication here
            }
        });
    }
    createAnimation (spritesheet, frames, frameRate, repeat = -1)
    {
        // Check if animation already exists before creating
        const animKey = spritesheet + '_ani';
        if (!this.scene.anims.exists(animKey)) {
            this.scene.anims.create({
                key: animKey,
                frames: this.anims.generateFrameNumbers(spritesheet, { start: 0, end: frames }),
                frameRate: frameRate,
                repeat: repeat
            });
        }
    }

    showOnfire() {
        this.createAnimation('blueFlame_spritesheet', 64, 30);
        this.onFireText.setVisible(true);
    
        // Check for device type
        const isDesktop = this.scene.sys.game.device.os.desktop;
        
        let spriteOffsets;
        
        if (isDesktop) {
            spriteOffsets = [
                { x: -50, y: 120 },
                { x: -20, y: 120 },
                { x: 50, y: 120 }
            ];
        } else {
            // Define offsets for mobile or other non-desktop devices
            spriteOffsets = [
                { x: 90 * this.scale, y: 130 },
                { x: 130 * this.scale, y: 130 },
                { x: 212 * this.scale, y: 130 }
            ];
        }
    
        // Rest of your logic for handling flames
        if (this.flameSprites.length === 0) {
            spriteOffsets.forEach((offset, index) => {
                const green_flame = this.scene.add.sprite(this.x + (offset.x * this.scale), this.y - (offset.y * this.scale), 'blueFlame_spritesheet');
                
                green_flame.setScale(1.8 * this.scale);
                green_flame.setDepth(this.depth + 2);
    
                if (index === 2) {
                    green_flame.flipX = true;
                    console.log("flipped");
                }
    
                // Check if animation exists before playing
                if (this.scene.anims.exists('blueFlame_spritesheet_ani')) {
                    green_flame.play('blueFlame_spritesheet_ani');
                }
                this.flameSprites.push(green_flame);
            });
        } else {
            this.flameSprites.forEach(flame => {
                // Check if animation exists and sprite is valid before playing
                if (flame && this.scene.anims.exists('blueFlame_spritesheet_ani') && !flame.anims.isPlaying) {
                    flame.play('blueFlame_spritesheet_ani');
                }
            });
        }
    }
    hideOnfire(){
        this.onFireText.setVisible(false);
        
        // Safely destroy each flame sprite and empty the array
        this.flameSprites.forEach(flame => {
            if (flame && flame.scene) {
                flame.destroy();
            }
        });
        this.flameSprites = [];
    }
    setNotifyVisible(toggle) {
        this.notifyImage.setVisible(toggle);
    }
    setChatVisible(toggle) {
        this.chatImage.setVisible(toggle);
    }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("namePanel", function (x, y, scale, pfp, name, isVip, isMe) {
    const namePanelInst = new NamePanel(this.scene, x, y, scale, pfp, name, isVip, isMe);

    this.displayList.add(namePanelInst);
    this.updateList.add(namePanelInst);

    return namePanelInst;
})